import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../redux/userSlice';

import MainBody from '../../components/layout/MainBody';
import Section from '../../components/layout/Section';
import TextField from '../../components/UI/TextField';
import Button from '../../components/UI/Button';


import LOGO from '../../assets/logo/logo.svg';
import { FONT } from '../../styles/color';

const Container = styled.div`
	width: 90%;
	max-width: 900px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 80px 0;
`;

const TextFieldWrapper = styled.div`
	width: 500px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 20px;
	margin-top: 70px;
`;

const SubButtonWrapper = styled.div`
	width: 500px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 15px;
`;

const SubButton = styled.button`
	background: none;
	border: none;
	font: normal 500 16px Pretendard Variable;
	color: ${ FONT.deep01 };
`;

const Link = {
	signUp: '/sign-up',
	findId: '/popUp/find-id',
	findPw: '/popUp/find-pw'
}

export default function Login() {
	const [formData, setFormData] = useState({
		id: '',
		password: ''
	});

	const { id, password } = formData;

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const isAuthenticated = useSelector((state) => state.user.isAuthenticated);

	useEffect(() => {
		if (isAuthenticated) {
			navigate('/');
		}
	}, [isAuthenticated, navigate]);

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (!id || !password) {
			alert('아이디와 비밀번호를 모두 입력해주세요.');
			return;
		}
		dispatch(loginUser({ id, password }));
	};

	const onClickButton = (path) => {
		navigate(path);
	}

	const onClickPopup = (path) => {
		window.open(path, 'popUp', 'width=605, height=405, top=200, left=500');
	};

  	return (
		<MainBody>
			<Section>
				<Container>
					<img src={ LOGO } width="350px"/>
					<TextFieldWrapper>
						<TextField type="text" $placeholder="아이디" name="id" value={id} onChange={ handleChange } />
						<TextField type="password" $placeholder="비밀번호" name="password" value={ password } onChange={handleChange} />
					</TextFieldWrapper>
					<Button buttonText="로그인" onClick={ handleSubmit } width="500px" style={{ marginTop: '50px' }}/>
					<SubButtonWrapper>
						<div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
							<SubButton onClick={ () => onClickPopup(Link.findId) }>아이디 찾기</SubButton>
							<SubButton onClick={ () => onClickPopup(Link.findPw) }>비밀번호 찾기</SubButton>
						</div>
						<SubButton onClick={ () => onClickButton(Link.signUp) }>회원가입</SubButton>
					</SubButtonWrapper>
				</Container>
			</Section>
		</MainBody>
  	);
}
